/* KMNCE main storefront — prototype JS
   Lightweight. No frameworks, no build step.
   ----------------------------------------------------------------- */

(function () {
  'use strict';

  // ---- Mobile nav toggle -------------------------------------------------
  const nav = document.getElementById('nav');
  const toggle = nav && nav.querySelector('.nav__toggle');
  if (toggle) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.querySelectorAll('.nav__links a').forEach((a) =>
      a.addEventListener('click', () => {
        nav.classList.remove('is-open');
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      })
    );
  }

  // ---- PDP: variant swatches -------------------------------------------
  document.querySelectorAll('[data-product]').forEach((scope) => {
    const groups = scope.querySelectorAll('[data-swatch-group]');
    if (!groups.length) return;

    // Parse Shopify variant catalog if present
    let variants = null;
    const variantsEl = scope.querySelector('[data-pdp-variants]');
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch { variants = null; }
    }

    // Helper: read currently-selected option value from each group
    const readSelection = () => {
      const sel = [];
      groups.forEach((g) => {
        const active = g.querySelector('.pdp__swatch.is-active');
        sel.push(active ? (active.dataset.optionValue || active.textContent.trim()) : null);
      });
      return sel;
    };

    // Helper: find variant whose options match selection
    const findVariant = (sel) => {
      if (!variants) return null;
      return variants.find((v) =>
        v.options.every((o, i) => sel[i] == null || o === sel[i])
      ) || null;
    };

    const updateForVariant = (variant) => {
      if (!variant) return;

      // Hidden id for cart submit
      const idInput = scope.querySelector('[data-pdp-variant-id]');
      if (idInput) idInput.value = variant.id;

      // Hero image (src + srcset so responsive picker also updates)
      if (variant.image) {
        const hero = scope.querySelector('[data-pdp-hero]')
                  || scope.querySelector('.pdp__gallery img');
        if (hero) {
          hero.src = variant.image;
          if (hero.srcset) hero.srcset = '';
          hero.removeAttribute('srcset');
        }
        // Sync active thumbnail
        scope.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
          t.classList.toggle('is-active', t.dataset.full === variant.image);
        });
      }

      // Price + compare-at
      const priceEl = scope.querySelector('[data-pdp-price]');
      const priceFromEl = scope.querySelector('[data-pdp-price-from]');
      const priceCurrentEl = scope.querySelector('[data-pdp-price-current]');
      const priceCompareEl = scope.querySelector('[data-pdp-price-compare]');
      // A specific variant is now selected — drop the "From" prefix.
      if (priceFromEl) priceFromEl.setAttribute('hidden', '');
      if (priceCurrentEl) {
        priceCurrentEl.textContent = variant.price_formatted;
      } else if (priceEl) {
        priceEl.textContent = variant.price_formatted;
      }
      if (priceCompareEl) {
        const onSale = variant.compare_at_price != null && Number(variant.compare_at_price) > Number(variant.price);
        if (onSale) {
          priceCompareEl.textContent = variant.compare_at_price_formatted || '';
          priceCompareEl.removeAttribute('hidden');
        } else {
          priceCompareEl.textContent = '';
          priceCompareEl.setAttribute('hidden', '');
        }
        if (priceEl) priceEl.classList.toggle('pdp__price--on-sale', onSale);
      }
      const btn = scope.querySelector('[data-pdp-submit]');
      const btnPrice = scope.querySelector('[data-pdp-btn-price]');
      if (btn) {
        btn.disabled = !variant.available;
        if (variant.available) {
          if (btnPrice) {
            btnPrice.textContent = variant.price_formatted;
          } else {
            btn.textContent = 'ADD TO CART — ' + variant.price_formatted;
          }
        } else {
          btn.textContent = 'SOLD OUT';
        }
      }
    };

    groups.forEach((group) => {
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('.pdp__swatch');
        if (!btn) return;
        group.querySelectorAll('.pdp__swatch').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        if (variants) {
          updateForVariant(findVariant(readSelection()));
          return;
        }

        // Legacy fallback: data-variant-images / data-variant-prices on the group
        const label = (btn.dataset.optionValue || btn.textContent.trim());
        const prices = group.dataset.variantPrices;
        if (prices) {
          let map; try { map = JSON.parse(prices); } catch { map = null; }
          const price = map && map[label];
          if (price != null) {
            const priceEl = scope.querySelector('.pdp__price');
            const atc = scope.querySelector('[data-add-to-cart]');
            if (priceEl) priceEl.textContent = '$' + price.toFixed(2);
            if (atc) {
              atc.dataset.price = String(price);
              atc.textContent = `ADD TO CART — $${price}`;
            }
          }
        }
        const images = group.dataset.variantImages;
        if (images) {
          let imap; try { imap = JSON.parse(images); } catch { imap = null; }
          const src = imap && imap[label];
          if (src) {
            const hero = scope.querySelector('[data-pdp-hero]')
                      || scope.querySelector('.pdp__gallery img');
            if (hero) {
              hero.src = src;
              hero.removeAttribute('srcset');
            }
            const atc = scope.querySelector('[data-add-to-cart]');
            if (atc) atc.dataset.image = src;
          }
        }
      });
    });
  });

  // ---- PDP: thumbnail gallery -------------------------------------------
  document.querySelectorAll('[data-pdp-thumbs]').forEach((thumbs) => {
    const scope = thumbs.closest('[data-product]') || document;
    const hero = scope.querySelector('[data-pdp-hero]');
    thumbs.addEventListener('click', (e) => {
      const t = e.target.closest('[data-pdp-thumb]');
      if (!t || !hero) return;
      const full = t.dataset.full;
      if (full) {
        hero.src = full;
        hero.removeAttribute('srcset');
      }
      thumbs.querySelectorAll('[data-pdp-thumb]').forEach((b) => b.classList.remove('is-active'));
      t.classList.add('is-active');
    });
  });

  // ---- PDP: quantity stepper --------------------------------------------
  document.querySelectorAll('.pdp__qty').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-qty="-"]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    qty.querySelector('[data-qty="+"]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // ---- Cart drawer -------------------------------------------------------
  const drawer = document.getElementById('cart-drawer');
  const cartCount = document.querySelector('.nav__cart-count');
  const cartBody = drawer && drawer.querySelector('.cart-drawer__body');
  const cartSubtotal = drawer && drawer.querySelector('[data-cart-subtotal]');
  const cart = []; // { id, title, variant, price, qty, image }

  const fmt = (n) => '$' + n.toFixed(2);

  function openCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-cart-open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-cart-open');
  }

  function renderCart() {
    if (!cartBody) return;
    if (cart.length === 0) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
    } else {
      cartBody.innerHTML = cart.map((line, i) => `
        <div class="cart-line">
          <div class="cart-line__media">${line.image ? `<img src="${line.image}" alt="">` : ''}</div>
          <div>
            <h3 class="cart-line__title">${line.title}</h3>
            <p class="cart-line__variant">${line.variant || ''}</p>
            <div class="cart-line__qty">
              <button data-cart-qty="-" data-i="${i}" aria-label="Decrease">−</button>
              <span>${line.qty}</span>
              <button data-cart-qty="+" data-i="${i}" aria-label="Increase">+</button>
            </div>
          </div>
          <div>
            <div class="cart-line__price">${fmt(line.price * line.qty)}</div>
            <button class="cart-line__remove" data-cart-remove="${i}">Remove</button>
          </div>
        </div>
      `).join('');
    }
    const total = cart.reduce((s, l) => s + l.price * l.qty, 0);
    if (cartSubtotal) cartSubtotal.textContent = fmt(total);
    if (cartCount) cartCount.textContent = String(cart.reduce((s, l) => s + l.qty, 0));
  }

  function addToCart(item) {
    const existing = cart.find((l) => l.id === item.id && l.variant === item.variant);
    if (existing) existing.qty += item.qty;
    else cart.push(item);
    renderCart();
    openCart();
  }

  // Open / close triggers
  document.querySelectorAll('[data-open-cart]').forEach((el) =>
    el.addEventListener('click', (e) => { e.preventDefault(); openCart(); })
  );
  drawer?.querySelector('.cart-drawer__close')?.addEventListener('click', closeCart);
  drawer?.querySelector('.cart-drawer__scrim')?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // Line item interactions (delegated)
  cartBody?.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { cart.splice(+remove.dataset.cartRemove, 1); renderCart(); return; }
    const qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      const i = +qty.dataset.i;
      cart[i].qty = Math.max(1, cart[i].qty + (qty.dataset.cartQty === '+' ? 1 : -1));
      renderCart();
    }
  });

  // Add-to-cart buttons (PDP + collection cards)
  document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const scope = btn.closest('[data-product]') || document;
      const activeSwatches = scope.querySelectorAll('[data-swatch-group] .pdp__swatch.is-active');
      const variant = Array.from(activeSwatches).map((s) => s.textContent.trim()).join(' · ');
      const qtyInput = scope.querySelector('.pdp__qty input');
      addToCart({
        id: btn.dataset.id || btn.dataset.addToCart,
        title: btn.dataset.title || 'Item',
        variant: variant || btn.dataset.variant || '',
        price: parseFloat(btn.dataset.price || '0'),
        qty: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1,
        image: btn.dataset.image || '',
      });
    });
  });

  renderCart();

  // ---- Newsletter --------------------------------------------------------
  // Klaviyo embed handles its own submit/validation; nothing to wire up here.
  // The section drops a <div class="klaviyo-form-XXXX"></div> placeholder
  // and loads //static.klaviyo.com/onsite/js/<company_id>/klaviyo.js.

  // ---- Respect reduced motion -------------------------------------------
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video[autoplay]').forEach((v) => {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }
})();
